<template>
  <div class="user-container">
    <div class="item">
      <div class="logo-box">
        <div
          v-if="walletProvider === 'metamask'"
          class="logo-circle"
        >
          <img
            src="/static/svg/wallet-metamask.svg"
            data-test="user-wallet--wallet-logo"
          >
        </div>
        <img
          v-else-if="walletProvider === 'cipher'"
          src="/static/img/cipher-logo.png"
          class="logo-wallet-img"
          data-test="user-wallet--wallet-logo"
        >
        <img
          v-else-if="walletProvider === 'coinbase-wallet'"
          src="/static/img/coinbase-wallet-logo.png"
          class="logo-wallet-img"
          data-test="user-wallet--wallet-logo"
        >
        <img
          v-else-if="walletProvider === 'trust'"
          src="/static/img/trust-logo.png"
          class="logo-wallet-img"
          data-test="user-wallet--wallet-logo"
        >
        <img
          v-else-if="walletProvider === 'wallet-connect'"
          src="/static/svg/wallet-connect.svg"
          class="logo-wallet-img"
          data-test="user-wallet--wallet-logo"
        >

        <div
          v-if="walletProvider === 'metamask'"
          class="connected-text"
          data-test="user-wallet--wallet-connected-text"
        >
          Metamask {{ $t('exchange.connected') }}
        </div>
        <div
          v-else-if="walletProvider === 'cipher'"
          class="connected-text"
          data-test="user-wallet--wallet-connected-text"
        >
          Cipher {{ $t('exchange.connected') }}
        </div>
        <div
          v-else-if="walletProvider === 'coinbase-wallet'"
          class="connected-text"
          data-test="user-wallet--wallet-connected-text"
        >
          Coinbase Wallet {{ $t('exchange.connected') }}
        </div>
        <div
          v-else-if="walletProvider === 'trust'"
          class="connected-text"
          data-test="user-wallet--wallet-connected-text"
        >
          Trust {{ $t('exchange.connected') }}
        </div>
        <div
          v-else-if="walletProvider === 'wallet-connect'"
          class="connected-text"
          data-test="user-wallet--wallet-connected-text"
        >
          Wallet Connect {{ $t('exchange.connected') }}
        </div>
        <div class="wallet-disconnect">
          <a
            class="wallet-disconnect-btn"
            @click="disconnect()"
          >
            {{ $t('exchange.disconnect') }}
          </a>
        </div>

      </div>
      <div class="content-box">
        <div class="gold-text">
          {{ $t('exchange.estimate_balance') }}
        </div>
        <div
          v-if="isLoading"
          class="balance-text"
          data-test="user-wallet--loading-text"
        >
          {{ $t('messages.loading') }}
        </div>
        <div
          v-else
          class="balance-text"
          data-test="user-wallet--estimated-usd-value"
        >
          ${{ estimatedValue | numberWithComma }}
        </div>
        <div class="gold-text">
          {{ $t('exchange.address_uppercase') }}
        </div>
        <div
          v-if="addrSplited !== ''"
          class="address-text"
        >
          {{ addrSplited }}
        </div>
        <div
          v-else
          class="address-text"
        >
          <div class="skt-center"><b-skeleton/></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
/**
 * UserWallet Component
 */
export default {
  name: 'UserWallet',
  props: {
    address: {
      type: String,
      default: ''
    },
    estimatedValue: {
      type: Object,
      default: () => {}
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    walletProvider: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      currentWeb3: state => state.currentWeb3
    }),
    addrSplited () {
      if (!this.address) return ''
      const first = this.address.substr(0, 13)
      const last = this.address.substr(29, this.address.length)
      return `${first}...${last}`
    }
  },
  methods: {
    async disconnect () {
      if (this.currentWeb3 && this.currentWeb3.currentProvider && this.currentWeb3.currentProvider.close) {
        console.log('close wallet provider', this.currentWeb3.currentProvider)
        await this.currentWeb3.currentProvider.close()
      }

      const isFoundInjectedWeb3 = typeof window.ethereum !== 'undefined'
      this.$store.dispatch('setCurrentWalletProvider', isFoundInjectedWeb3 ? 'metamask' : 'unknown')
      this.$store.dispatch('setCurrentWeb3', undefined)

      this.$store.dispatch('setCurrentNetwork', 'disconnected')
      this.$store.dispatch('setWallets', [])
      this.$store.dispatch('setIsWalletConnected', false)
    }
  }
}
</script>

<style scoped lang="scss">
.user-container {
  float: left;
  width: 100%;
}
.item {
  float: left;
  width: 100%;
  padding: 30px 15px;
  box-shadow: 0 2px 4px 0 rgba(85, 85, 85, 0.5);
  margin-bottom: 20px;
  border-radius: 3px;
  background-color: #3f5eab;
}
.logo-box {
  float: left;
  width: 200px;
  margin-right: 10px;
  text-align: center;
}
.logo-circle {
  width: 130px;
  height: 130px;
  background-color: #34495e;
  border-radius: 50%;
  text-align: center;
  margin: 0 auto;
  line-height: 130px;
  img {
    width: 90px;
    height: 90px;
    vertical-align: middle;
  }
}
.logo-wallet-img {
  width: 120px;
  height: 120px;
  margin: 0 auto;
}
.connected-text {
  font-size: 13px;
  font-weight: bold;
  color: #50e3c2;
  margin-top: 15px
}
.help-text {
  font-size: 13px;
  color: #50e3c2 !important;
  margin-top: 5px;
  text-decoration: underline;
}
.content-box {
  float: left;
  width: calc(100% - 200px - 10px);
  text-align: center;
  color: #fff;
}
.gold-text {
  float: left;
  width: 100%;
  font-weight: bold;
  color: #ffcf00;
}
.balance-text {
  float: left;
  width: 100%;
  font-family: DINAlternate !important;
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 13px;
  margin-bottom: 45px;
}
.address-text {
  float: left;
  width: 100%;
  margin-top: 3px;
  font-family: DINAlternate !important;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.4px;
}
.skt-center {
  width: 30%;
  margin: 0 auto;
}
.wallet-disconnect {
  float: left;
  width: 100%;
  margin-top: 23px;
  max-width: 240px;
}
.wallet-disconnect-btn {
  background: transparent;
  color: #fff;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 10px;
  width: 100%;
  display: block;
  text-align: center;

  &:hover {
    color: #3f5eab;
    background-color: #fff;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .logo-box {
    width: 100%;
  }
  .content-box {
    width: 100%;
  }
  .help-text {
    display: block;
    margin-bottom: 30px;
  }
  .balance-text {
    margin-bottom: 30px;
  }
  .wallet-disconnect {
    margin-bottom: 23px;
    max-width: unset;
  }
  .wallet-disconnect-btn {
    width: 170px;
    margin: 0 auto;
  }
}
</style>

<docs>
```js
  <UserWallet/>
```
</docs>



// WEBPACK FOOTER //
// src/features/UserAssets/components/UserWallet.vue